module.exports = __webpack_public_path__ + "static/media/11.ebcb4152.jpg";